import { render, staticRenderFns } from "./LabSimpleDistillation.vue?vue&type=template&id=698151b0&"
import script from "./LabSimpleDistillation.vue?vue&type=script&lang=ts&"
export * from "./LabSimpleDistillation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports